document.addEventListener('DOMContentLoaded', function() {
    let reviewsSlider = $('.r-slider__list').slick({
        centerMode: true,
        variableWidth: true,
        dots: false,
        prevArrow: '<button type="button" class="r-slider__btn slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">\n' +
            '  <path d="M18.8623 24.8996L10.7123 16.7496C9.7498 15.7871 9.7498 14.2121 10.7123 13.2496L18.8623 5.09961" stroke="#FBE8AF" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        nextArrow: '<button type="button" class="r-slider__btn slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">\n' +
            '  <path d="M11.1377 24.8996L19.2877 16.7496C20.2502 15.7871 20.2502 14.2121 19.2877 13.2496L11.1377 5.09961" stroke="#FBE8AF" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    // arrows: false,
                }
            }
        ]
    })

    reviewsSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.r-slider__pag [data-current-slide]').html($('.r-slider .slick-current .r-slider__item').attr('data-index'));
    });

    $('.col-tabs__tab').click(function() {
        let index = $(this).attr('data-index');
        $('.col-tabs__tab').removeClass('active');
        $(this).addClass('active')
        $('.col-tabs__tab-content').removeClass('active');
        $(`.col-tabs__tab-content[data-index="${index}"]`).addClass('active');
    })

    $('.thumbnail-list').slick({
        vertical: true,
        slidesToShow: 5,
        infinite: false,
        prevArrow: '<button class="thumbs__arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="95" height="50" viewBox="0 0 95 50" fill="none">\n' +
            '  <rect x="94" y="1" width="48" height="93" rx="7" transform="rotate(90 94 1)" fill="white"/>\n' +
            '  <rect x="94" y="1" width="48" height="93" rx="7" transform="rotate(90 94 1)" stroke="#1C1C1E" stroke-width="2"/>\n' +
            '  <path d="M30 20L44.4066 29.1863C46.108 30.2712 48.892 30.2712 50.5934 29.1863L65 20" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        nextArrow: '<button class="thumbs__arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="95" height="50" viewBox="0 0 95 50" fill="none">\n' +
            '  <rect x="94" y="1" width="48" height="93" rx="7" transform="rotate(90 94 1)" fill="white"/>\n' +
            '  <rect x="94" y="1" width="48" height="93" rx="7" transform="rotate(90 94 1)" stroke="#1C1C1E" stroke-width="2"/>\n' +
            '  <path d="M30 20L44.4066 29.1863C46.108 30.2712 48.892 30.2712 50.5934 29.1863L65 20" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>'
    })

    $('.f-col__list').slick({
        variableWidth: true,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="f-col__btn slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">\n' +
            '  <path d="M21.3452 28.1383L12.1765 18.9695C11.0937 17.8867 11.0937 16.1148 12.1765 15.032L21.3452 5.86328" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        nextArrow: '<button type="button" class="f-col__btn slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">\n' +
            '  <path d="M12.6548 28.1383L21.8235 18.9695C22.9063 17.8867 22.9063 16.1148 21.8235 15.032L12.6548 5.86328" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false
                }
            }
        ]
    })

    $('.col2__img-btn').click(function() {
        $(this).hide();
        $(this).siblings('img').addClass('hide');
        $(this).siblings('video').show();
        $(this).siblings('video')[0].play();
    })

    $(document).on('click', '#product-grid .quick-add__submit', function(e) {
        e.preventDefault();
        let id = +$(e.target).closest('.quick-add__submit').siblings('.product-variant-id').val();
        let cartNotification = document.querySelector('cart-notification');

        $.ajax({
            type: 'post',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id,
                quantity: 1
            },
            success: data => {
                console.log(data)
                cartNotification.open();
                $('#cart-notification-product').html(`<div class="cart-notification-product__image global-media-settings">
                      <img src="${data.image}" alt="" width="70" height="70" loading="lazy">
                    </div><div><h3 class="cart-notification-product__name h4">${data.title}</h3>
                    <dl></dl></div>
                `)
            }
        })
    })

    $(document).on('change', '.product__buy [name="selling_plan"]', function() {
        console.log('ggg')
        let input = $('.product__buy [name="selling_plan"]:checked')
        let price = input.closest('div').find('.appstle_subscription_amount').html();
        let comparePrice = input.closest('div').find('.appstle_subscription_compare_amount').html();
        let plan = input.siblings('label').find('.appstle_one_time_text').html();
        if(!plan || !plan.length) {
            plan = input.siblings('label').find('.appstle_subscribe_save_text').html();
        }
        $('[data-sticky-plan]').html(plan);
        $('.p-sticky__price').html(price);
        console.log(comparePrice)
        if(comparePrice) {
            $('.p-sticky__price--compare').html(comparePrice);
            $('.p-sticky__price--compare').show();
        } else {
            $('.p-sticky__price--compare').html('');
            $('.p-sticky__price--compare').hide();
        }
    })

    $('.p-sticky__form .quantity__input').change(function() {
        $('.product__buy .quantity__input').val($(this).val())
    })

    $('.product__buy .quantity__input').change(function() {
        $('.p-sticky__form .quantity__input').val($(this).val())
    })

    $('.p-sticky__btn').click(function() {
        $('.product-form__submit').click();
    })

    $('.g-slider__list').slick({
        slidesToShow: 4,
        variableWidth: true,
        prevArrow: '<button type="button" class="g-slider__btn slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">\n' +
            '  <path d="M18.8623 24.8996L10.7123 16.7496C9.7498 15.7871 9.7498 14.2121 10.7123 13.2496L18.8623 5.09961" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        nextArrow: '<button type="button" class="g-slider__btn slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">\n' +
            '  <path d="M11.1377 24.8996L19.2877 16.7496C20.2502 15.7871 20.2502 14.2121 19.2877 13.2496L11.1377 5.09961" stroke="#1C1C1E" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg></button>',
        infinite: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    variableWidth: true,
                    arrows: false,
                    slidesToShow: 1
                }
            }
        ]
    })

    $('.g-slider__slide').click(function() {
        $('.g-slider__popup').empty();
        $('.g-slider__popup').addClass('active');
        let video = $(this).attr('data-video')
        if(video.length) {
            $('.g-slider__popup').html(`
                <video src="${video}" autoplay controls>
                </video>
            `)
        } else {
            let src = $(this).attr('data-img');
            $('.g-slider__popup').html(`
                <img src="${src}">
            `)
        }
    })

    $('.g-slider__popup').click(function(e) {
        if(!$(e.target).closest('video').length) {
            $('.g-slider__popup').removeClass('active');
            $('.g-slider__popup video')[0].pause()
        }
    })

    let productFormBtns = '.product__buy .product-form__buttons';
    if($(productFormBtns).length) {
        $(window).scroll(() => {
            if(isInViewport(productFormBtns)) {
                $('.p-sticky').removeClass('active');
            } else {
                $('.p-sticky').addClass('active');
            }
        })
    }

    let isInViewport = function(elem) {
        var elementTop = $(elem).offset().top;
        var elementBottom = elementTop + $(elem).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop || (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight
    };
})